import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '@mui/material/Button';
import useCopyLinkButton from './useCopyLinkButton';
import { useStyles } from './styles';

export function CopyLinkButton (props) {
    const {
        inProgress = false,
        onClick = () => {},
        buttonClass = {},
        iconClass = '',
        copyLabel = 'Copy link',
        copiedLabel = 'Link copied!',
    } = props;

    const classes = useStyles();

    const {
        buttonLabel,
        showIcon,
    } = useCopyLinkButton({
        inProgress,
        copyLabel,
        copiedLabel,
    });

    return (
        <Button
            classes={{ root: classNames(["data-ecal-copy-link-button", buttonClass]) }}
            onClick={() => onClick()}
        >
            { showIcon && <span className={classNames([classes.iconImage, iconClass])} /> }
            { buttonLabel }
        </Button>
    );
}

CopyLinkButton.propTypes = {
    inProgress: PropTypes.bool,
    onClick: PropTypes.func,
    buttonClass: PropTypes.any,
    iconClass: PropTypes.string,
    copyLabel: PropTypes.string,
    copiedLabel: PropTypes.string,
};

export default CopyLinkButton;